import React from 'react'
// import classNames from 'classnames'
// import loaderIMG from './loader.svg'
import styles from './style.module.scss'

const Loader = () => (
  <div className={styles.loader}>
    <img src={`${process.env.PUBLIC_URL}/resources/img/loader.svg`} alt="loading" />
  </div>
)

export default Loader
